import { AfterViewInit, Component, EventEmitter, HostListener, OnInit, Output, ViewChild ,Renderer2, Input } from "@angular/core";
import { CartItem } from "src/app/modals/cart-item";
import { CartService } from "../services/cart.service";
import { AppSettings, Settings } from "../services/color-option.service";
import { TranslateService } from "@ngx-translate/core";
import { AccountService } from "../services/account.service";
import { UserService } from "../services/user.service";
import { DSProduct } from "src/app/modals/dsproduct.modal";
import { UserServiceModal } from "src/app/modals/userservice.modal";
import { Router } from "@angular/router";
import { RestApiService } from "../services/restapi.service";
import { MatDialog } from "@angular/material/dialog";
import { ItemsListService } from "../services/itemsList.service";
import { environment } from 'src/environments/environment';
import { CompanyService } from "../services/company.service";
import { ConfigService } from "../services/config.service";
import { ProductService } from "../services/product.service";
import * as _ from "lodash";
import { MatMenuTrigger } from "@angular/material/menu";
import { UtilityService } from "../services/utility.service";
import { LoginDialogComponentComponent } from "../login-dialog-component/login-dialog-component.component";
import { SideNavBarService } from "../services/sidenavbar.service";
import { MarketSelectorComponent } from "../model/market-selector/market-selector.component";
import { CORPORATESTOREID, DefaultCountry, RETAILSTOREID } from "src/app/constant";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit, AfterViewInit {
  @Output() sildeMobileNavEvent = new EventEmitter<any>();
  @ViewChild('shopMenuTrigger', { static: true }) shopMenuTrigger: MatMenuTrigger;
  public currencies = ["USD", "EUR"];
  public currency: any;
  public flag: any;
  public userService: UserServiceModal;
  userServiceModal: UserServiceModal;
  products: Array<DSProduct>;
  shoppingCartItems: CartItem[] = [];
  public settings: Settings;
  isTop: boolean = true;
  currentRouterPath: any;
  isAllunselect: boolean;
  RegionIDForRequest: any;
  selectedCategory: any = { Category: "all", CategoryId: -1 };
  env: any;
  selectedCategoryId: any;
_forMobileScreen:boolean;
_ScreenSize:any;
mobileView:boolean = false;
@Input() childClass:string = '';
@HostListener('window:resize', ['$event'])
@ViewChild(MatMenuTrigger) menuTrigger: MatMenuTrigger;
onResize(event: any) {
  this._forMobileScreen = event.target.innerWidth <= 768;
}

isMenuOpen = false;
  constructor(
  private renderer: Renderer2,
    private accountService: AccountService,
    private cartService: CartService,
    public appSettings: AppSettings,
    public translate: TranslateService,
    public user: UserService,
    public router: Router,
    public apiService: RestApiService,
    public UserService: UserService,
    public dialog: MatDialog,
    public itemsListService: ItemsListService,
    public companyService: CompanyService,
    private productService: ProductService,
    public configService: ConfigService,
    public utilityService: UtilityService,
    private SideNavBarService:SideNavBarService
  ) {
    this.userServiceModal = this.UserService?.userServiceModal;
    this.settings = this.appSettings.settings;
    this.userService = this.user.userServiceModal;
    this.cartService.getItems().subscribe((shoppingCartItems) => (this.shoppingCartItems = shoppingCartItems));
    this.router.events.subscribe((event) => { this.currentRouterPath = router.url; });
    this.env=environment;
  }

  ngOnInit() {
    this._forMobileScreen = window.innerWidth <= 768;
    this._ScreenSize=window.innerWidth

    if(this._forMobileScreen==true){
      this.mobileView=true;
    }else{
      this.mobileView=false;
    }
    this.currency = this.currencies[0];
    let a = sessionStorage.getItem('selectedCountry')
    this.configService.getCommonSetting(a, sessionStorage.getItem('SelectedLanguage')).then(() => {
      this.userServiceModal.selectedCountry = a
      this.RegionIDForRequest = this.companyService.getRegionID(a || this.userServiceModal?.selectedCountry || DefaultCountry)
      this.getAllProductItems(this.RegionIDForRequest);
    });
  }

  ngAfterViewInit() {
    this._forMobileScreen = window.innerWidth <= 768;
    this._ScreenSize=window.innerWidth

    this.menuTrigger.menuOpened.subscribe(() => {
      // Wait for the overlay to be rendered
      setTimeout(() => {
        const overlayContainer = document.querySelector('.cdk-overlay-container') as HTMLElement;
        if (overlayContainer) {
          this.renderer.setStyle(overlayContainer, 'top', '0px');
        }
      });
    });
  }

  toggleMobileMenu($event) {
    this.sildeMobileNavEvent.emit($event);
  }
  changeCurrency(currency) {
    this.currency = currency;
  }
  changeLang(flag) {
    this.flag = flag;
  }
  logout() {
    this.accountService.logout();
  }
  login() {
    window.open('https://office2.commonsenseww.com/#/Login','_blank');
    // this.dialog.open(LoginDialogComponentComponent, {
    //   width: "600px",
    //   autoFocus: false
    // })
  }
  @HostListener("window:scroll", ["$event"])
  onScroll(): void {
    if (window.scrollY > 60) {
      this.isTop = false;
    } else {
      this.isTop = true;
    }
  }
  isLoggedIn() {
    if (
      Object.keys(this.userService.customerData).length &&
      this.userService.customerData.CustomerId &&
      this.user.checkIfUserAuthenticatedOrNot()
    ) {
      return true;
    } else {
      return false;
    }
  }

  backoffice() {
    let windowReference = window.open();
    let request = {
      CustomerID: this.userService.customerData.CustomerId,
      Dest: 'home'
    }
    this.apiService.getCustomerSSOURL(request).subscribe((result) => {
      windowReference.location = result.Data
    })
  }
  openDialogs() {
      this.router.navigate(['/shop']);
  }
  onChange(selectedCategory) {
    this.itemsListService.products = this.products.filter(product => product.CategoryId === selectedCategory).sort((a, b) => a.Category.localeCompare(b.Category)).slice(0, 9);
    this.selectedCategoryId = selectedCategory; 
  }
  getAllProductItems(RegionID?) {
    this.selectedCategory = { CategoryId: "all" };
    const request = {
      RegionID: RegionID || 1,
      CategoryId: "all",
      StoreID: this.productService.isLoggedIn() ? (this.userService?.customerData?.IsCorporate == true ?  CORPORATESTOREID : RETAILSTOREID) : RETAILSTOREID,
    };
    //main request for api calling
    this.productService.getProductByCategory(request).subscribe((products) => {
      this.productService.orders = products.map((item) => {
        item.Price = item.Price || (item.Prices && item.Prices[0] && item.Prices[0].Price);
        return item;
      });

      //filling unique products according to category
      const uniqueRequireProduct = ([] = _.uniqBy(products, (x) => x.CategoryId));

      //selected category data filling
      this.itemsListService.selectedCategories = {};
      if (this.selectedCategory.CategoryId == "all") {
        this.itemsListService.selectedCategories["all"] = true;
      }
      //itemlistservice categorylist data filling
      this.itemsListService.categoryList = _.map(uniqueRequireProduct, (object) => { return _.pick(object, ["CategoryId", "Category"]); });

      //empty product array
      this.products = [];

      const product = (this.itemsListService.products = this.productService.orders);

      product.filter((x) => {
        if (x.Category) {
          this.products.push(x);
        }
      });
      //filling products here in the html use to display products
      this.itemsListService.products = this.products;
      this.onChange(this.itemsListService.products[0]?.CategoryId);
      this.itemsListService.type = "order";

      //displaying according to category
      var category;
      this.itemsListService.categoryList.filter((x) => {
        if (x.CategoryId == this.selectedCategory.CategoryId) {
          category = x.Category;
        }
      });
      if (this.selectedCategory.CategoryId == "all") {
        this.itemsListService.getItemsByCategory("all");
      } else {
        this.itemsListService.getItemsByCategory(category);
      }
    });
    this.env = environment;
  }
  navigateToProduct(product:any)
  {
    this.router.navigate(['/product'], { queryParams: { id: product.ItemID } });
    this.shopMenuTrigger.closeMenu();
  }

  // toggleMenu(){
  //   this.dialog.open(HeaderDropdownDailogComponent, {
  //     width: "100%",
  //     autoFocus: false
  //   })
  // }
  @HostListener('window:resize', ['$event'])
  onWindowResize(event: Event) {
    this.windowResize(event);
  }
  windowResize(event: Event): void {
    this._forMobileScreen = window.innerWidth <= 768;
    this._ScreenSize=window.innerWidth
    if(this._forMobileScreen ==true){
      this.mobileView=true;
    }else{
      this.mobileView=false;
      this.paddingBottomValue = '0px';
    }

  }
  paddingBottomValue = '0px';

  openLogin(){
    this.dialog.open(LoginDialogComponentComponent, {
         width: "600px",
        autoFocus: false
       })
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
    if(this.isMenuOpen) {
        (document.getElementById('mobile-menus') as HTMLElement)?.classList?.remove('animate-slideInUp');
        (document.getElementById('mobile-menus') as HTMLElement).classList.add('animate-slideInDown');
    }else {
      (document.getElementById('mobile-menus') as HTMLElement)?.classList?.remove('animate-slideInDown');
      (document.getElementById('mobile-menus') as HTMLElement).classList.add('animate-slideInUp');
    }
  }

  sideBarOpen(){
    this.SideNavBarService.openSidePanel();
  }

  getOrderQuanity() {
    let quantity = 0;
    if (this.isLoggedIn() && this.productService.selectedOrderItems.length == 0 && this.productService.selectedAutoOrderItems.length > 0) {
      _.each(this.productService.selectedAutoOrderItems, (item) => {
        if (!item.UsePoints) {
          quantity += (item.Quantity ? parseInt(item.Quantity, 10) : 0);
        }
        if (item.UsePoints) {
          quantity += (item.rewardQuantity ? parseInt(item.rewardQuantity, 10) : 0);
        }
      });
    }
    else {
      _.each(this.productService.selectedOrderItems, (item) => {
        if (!item.UsePoints) {
          quantity += (item.Quantity ? parseInt(item.Quantity, 10) : 0);
        }
        if (item.UsePoints) {
          quantity += (item.rewardQuantity ? parseInt(item.rewardQuantity, 10) : 0);
        }
      });
    }
    return quantity;
  }
  ShopNowMarketSelector() {
    if(!this.router.url.includes('shop')){
      if(this.isLoggedIn()){
        this.router.navigate(['/shop']);
      }else{
        const dialogRef = this.dialog.open(MarketSelectorComponent, {
          height: 'auto',
        });
        dialogRef.afterClosed().subscribe(result => {
          // this.router.navigate(['/shop']);
          if (!result) {
            return;
        }
        });
        }
    }
    }
  }
